(function ($) {
    $('.consent-banner .accordion-header').on('click', function (event) {
        if ($(event.target).is('input[type="checkbox"], .slider')) {
            event.stopPropagation();
            return;
        }

        const $thisAccordion = $(this).parent('.accordion-item');
        const $allAccordions = $('.consent-banner .accordion-item');
        const $accordionToggle = $(this).find('.accordion-toggle');

        if (!$thisAccordion.hasClass('active')) {
            $allAccordions.not($thisAccordion)
                .removeClass('active')
                .find('.accordion-content').slideUp()
                .find('.cookie-accordion-content').slideUp();

            $('.accordion-toggle').text('+');
            $('.cookie-accordion-toggle').text('+');
        }

        $(this).next('.accordion-content').slideToggle();
        $thisAccordion.toggleClass('active');

        $accordionToggle.text($thisAccordion.hasClass('active') ? '-' : '+');
    });

    $(document).on('click', '.cookie-accordion-header', function () {
        const $thisSubAccordion = $(this).next('.cookie-accordion-content');
        const $allSubAccordions = $(this).closest('.accordion-content').find('.cookie-accordion-content');
        const $cookieToggle = $(this).find('.cookie-accordion-toggle');

        if (!$thisSubAccordion.is(':visible')) {
            $allSubAccordions.not($thisSubAccordion).slideUp();
            $('.cookie-accordion-toggle').text('+');
        }

        $thisSubAccordion.slideToggle();

        $cookieToggle.text($thisSubAccordion.is(':visible') ? '-' : '+');
    });

    $('[data-consent-banner-confirm-choices]').on('click', function (event) {
        event.preventDefault();
        confirmChoices();
        hideBanner();
    });

    $('[data-consent-banner-accept-all]').on('click', function (event) {
        event.preventDefault();
        acceptAll();
        hideBanner();
    });

    const COOKIE_NAME = 'wp_theme_consent_settings';
    const COOKIE_EXPIRY_DAYS = 999;

    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "; expires=" + date.toUTCString();
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function updateConsent(adStorage, analyticsStorage, adUserData, adPersonalization, functionalityStorage, personalizationStorage) {
        if (typeof gtag !== 'undefined') {
            gtag('consent', 'update', {
                'ad_storage': adStorage,
                'analytics_storage': analyticsStorage,
                'ad_user_data': adUserData,
                'ad_personalization': adPersonalization,
                'functionality_storage': functionalityStorage,
                'security_storage': 'granted',
                'personalization_storage': personalizationStorage
            });
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'consent_update',
            'ad_storage': adStorage,
            'analytics_storage': analyticsStorage,
            'ad_user_data': adUserData,
            'ad_personalization': adPersonalization,
            'functionality_storage': functionalityStorage,
            'security_storage': 'granted',
            'personalization_storage': personalizationStorage
        });
    }

    function initBanner() {
        const consentCookie = getCookie(COOKIE_NAME);
        if (!consentCookie) {
            showBanner();
        } else {
            try {
                const consent = JSON.parse(consentCookie);

                $('[data-consent-banner-choice="analytics"]').prop('checked', consent.analytics === 'granted');
                $('[data-consent-banner-choice="marketing"]').prop('checked', consent.marketing === 'granted');
                $('[data-consent-banner-choice="settings"]').prop('checked', consent.settings === 'granted');
                $('[data-consent-banner-choice="functional"]').prop('checked', consent.functional === 'granted');

                updateConsent(
                    consent.marketing === 'granted' ? 'granted' : 'denied',
                    consent.analytics === 'granted' ? 'granted' : 'denied',
                    consent.marketing === 'granted' ? 'granted' : 'denied',
                    consent.marketing === 'granted' ? 'granted' : 'denied',
                    consent.functional === 'granted' ? 'granted' : 'denied',
                    consent.settings === 'granted' ? 'granted' : 'denied'
                );
            } catch (e) {
                console.error("Error parsing consent cookie: ", e);
                showBanner();
            }
        }
    }

    function showBanner() {
        $('.consent-banner').addClass('active');
    }

    function hideBanner() {
        $('.consent-banner').removeClass('active');
    }

    function acceptAll() {
        $('.toggle-switch input').prop('checked', true);
        updateConsent('granted', 'granted', 'granted', 'granted', 'granted', 'granted');
        setCookie(COOKIE_NAME, JSON.stringify({
            marketing: 'granted',
            analytics: 'granted',
            settings: 'granted',
            functional: 'granted'
        }), COOKIE_EXPIRY_DAYS);
    }

    function confirmChoices() {
        // current states
        const isAnalyticsChecked = $('[data-consent-banner-choice="analytics"]').is(':checked');
        const isMarketingChecked = $('[data-consent-banner-choice="marketing"]').is(':checked');
        const isSettingsChecked = $('[data-consent-banner-choice="settings"]').is(':checked');
        const isFunctionalChecked = $('[data-consent-banner-choice="functional"]').is(':checked');

        // save current state
        setCookie(COOKIE_NAME, JSON.stringify({
            marketing: isMarketingChecked ? 'granted' : 'denied',
            analytics: isAnalyticsChecked ? 'granted' : 'denied',
            settings: isSettingsChecked ? 'granted' : 'denied',
            functional: isFunctionalChecked ? 'granted' : 'denied'
        }), COOKIE_EXPIRY_DAYS);

        // update
        updateConsent(
            isMarketingChecked ? 'granted' : 'denied',
            isAnalyticsChecked ? 'granted' : 'denied',
            isMarketingChecked ? 'granted' : 'denied',
            isMarketingChecked ? 'granted' : 'denied',
            isFunctionalChecked ? 'granted' : 'denied',
            isSettingsChecked ? 'granted' : 'denied'
        );
    }

    // toggle change
    $('.toggle-switch input').on('change', function () {
        confirmChoices();
    });

    $(document).ready(function () {
        initBanner();

        $('[data-consent-banner-confirm-choices]').on('click', function (event) {
            event.preventDefault();
            confirmChoices();
            hideBanner();
        });

        $('[data-consent-banner-accept-all]').on('click', function (event) {
            event.preventDefault();
            acceptAll();
            hideBanner();
        });
    });

    window.showConsentBanner = showBanner;

})(jQuery);
